/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs'

const $nsid = 'app.bsky.unspecced.searchStarterPacksSkeleton'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  q: /*#__PURE__*/ l.string(),
  viewer: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      25,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  hitsTotal: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  starterPacks: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<UnspeccedDefs.SkeletonSearchStarterPack>(
      (() => UnspeccedDefs.skeletonSearchStarterPack) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Backend Starter Pack search, returns only skeleton. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['BadQueryString'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
